<template>
  <div class="col-12 page_content_area">
    <div class="container students_content_area">
      <div class="row mb-5 justify-content-center">
        <div class="col-lg-8 col-sm-12">
          <portlet variant="gray">
            <div>
              <form-row>
                <form-group cols="12">
                  <input-group class="justify-content-end">
                    <template slot="prepend">
                      <span class="input-group-text text-muted">
                        關鍵字搜尋
                      </span>
                    </template>
                    <template slot="append">
                      <span
                        aria-hidden="true"
                        class="input-group-text advanced-button text-muted btn-pill"
                      >
                        <button-wrapper
                          class="pill pill--xs outline_gray"
                          @click.prevent="toggleAdvancedSearchField"
                        >
                          進階搜尋
                        </button-wrapper>
                      </span>

                      <span
                        v-show="!doesActiveAdvancedSearching"
                        aria-hidden="true"
                        class="input-group-text search-icon text-muted"
                        @click="searchJobs"
                      >
                        <font-awesome-icon icon="search" />
                      </span>
                    </template>
                    <form-input
                      v-model="query.keywords"
                      placeholder="請輸入公司名稱或職缺名稱"
                      name="job_search_keywords"
                      style="width: 120px;"
                    />
                  </input-group>
                </form-group>
              </form-row>
              <template v-if="doesActiveAdvancedSearching">
                <form-row>
                  <form-group
                    class="col-sm-6"
                  >
                    <input-group>
                      <template slot="prepend">
                        <span class="input-group-text text-muted">
                          產業類型
                        </span>
                      </template>
                      <form-select
                        :default-value="query.region"
                        :options="categoriesGetter"
                        name="job_category"
                        select-name="category_name"
                        select-value="category_value"
                        @change="selectCategory"
                      />
                    </input-group>
                  </form-group>
                </form-row>
                <form-row>
                  <form-group
                    class="col-sm-6 mb-0"
                  >
                    <input-group>
                      <template slot="prepend">
                        <span class="input-group-text text-muted">
                          工作地區
                        </span>
                      </template>
                      <form-select
                        :options="regionsGetter"
                        name="job_region"
                        select-name="name"
                        select-value="id"
                        @change="selectRegion"
                      />
                    </input-group>
                  </form-group>
                  <form-group
                    class="col-sm-6"
                  >
                    <input-group>
                      <form-input
                        v-model="query.subregion"
                        placeholder="請輸入地名"
                        name="job_search_area"
                      />
                    </input-group>
                  </form-group>
                </form-row>
                <form-row>
                  <form-group
                    class="col-sm-6"
                  >
                    <input-group>
                      <template slot="prepend">
                        <span class="input-group-text text-muted">
                          職業身份
                        </span>
                      </template>
                      <form-select
                        :options="identitiesGetter"
                        name="job_identity"
                        select-name="identity_name"
                        select-value="identity_value"
                        @change="selectIdentity"
                      />
                    </input-group>
                  </form-group>
                  <form-group
                    class="col-sm-6"
                  >
                    <input-group>
                      <template slot="prepend">
                        <span class="input-group-text text-muted">
                          科系要求
                        </span>
                      </template>
                      <form-select
                        :options="departmentsGetter"
                        name="job_department"
                        select-name="department_name"
                        select-value="department_value"
                        @change="selectDepartment"
                      />
                    </input-group>
                  </form-group>
                </form-row>
                <form-row>
                  <form-group
                    class="col-7 offset-5"
                  >
                    <button-wrapper
                      thickness="sm"
                      color="pink"
                      @click.prevent="resetQueryString"
                    >
                      清除
                    </button-wrapper>
                    <button-wrapper
                      thickness="sm"
                      @click.prevent="searchJobs"
                    >
                      <font-awesome-icon icon="search" />
                    </button-wrapper>
                  </form-group>
                </form-row>
              </template>
            </div>
          </portlet>
        </div>
      </div>
      <div class="row">
        <div class="col-12 p-0">
          <portlet>
            <template slot="footer">
              <div class="row justify-content-center pt-4 pb-4">
                <bootstrap-pagination
                  v-if="pageGetter.page_total > 1"
                  :total-page-number="pageGetter.page_total"
                  @number:updated="updateJobsPage"
                />
              </div>
            </template>
            <table-wrapper class="table_scroll">
              <table-row class="table_width">
                <table-heading>
                  時間
                </table-heading>
                <table-heading>
                  職位
                </table-heading>
                <table-heading>
                  公司名稱
                </table-heading>
                <table-heading>
                  產業類型
                </table-heading>
                <table-heading>
                  職業身份
                </table-heading>
                <table-heading>
                  地區
                </table-heading>
              </table-row>
              <template
                v-if="currentPageJobsGetter"
              >
                <table-row
                  v-for="job in currentPageJobsGetter"
                  :key="job.job_id"
                  programmatic-navigation
                  class="table_width"
                  @row:selected="selectedRow($event, job.job_id)"
                >
                  <table-data>
                    {{ job.job_published_at || new Date() | moment("YYYY/MM/DD") }}
                  </table-data>
                  <table-data>
                    {{ job.job_title }}
                  </table-data>
                  <table-data>
                    {{ job.job_company }}
                  </table-data>
                  <table-data>
                    {{ job.job_industry }}
                  </table-data>
                  <table-data>
                    <tag :is-wide="false">
                      {{ job.job_identity }}
                    </tag>
                  </table-data>
                  <table-data>
                    {{ job.job_region }}
                  </table-data>
                </table-row>
              </template>
              <template v-else>
                <table-row>
                  <table-data>
                    <span class="text-center w-100 d-inline-block">
                      還沒有資料可以顯示
                    </span>
                  </table-data>
                </table-row>
              </template>
            </table-wrapper>
          </portlet>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BootstrapPagination from '~bootstrap/Pagination'
import Portlet from '~components/common/Portlet'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import Tag from '~components/common/Tag'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import InputGroup from '~components/common/form/input/Group'
import ButtonWrapper from '~components/common/buttons'
import FormSelect from '~components/common/form/Select'
export default {
  name: 'JobOpeningZhContent',
  components: {
    BootstrapPagination,
    Portlet,
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    Tag,
    FormRow,
    FormGroup,
    FormInput,
    InputGroup,
    ButtonWrapper,
    FormSelect
  },
  data () {
    return {
      doesActiveAdvancedSearching: false,
      query: {}
    }
  },
  computed: {
    ...mapGetters('pages/jobs', [
      'categoriesGetter',
      'identitiesGetter',
      'departmentsGetter',
      'regionsGetter',
      'subregionsGetter',
      'currentPageJobsGetter',
      'currentPageGetter',
      'pageGetter',
      'allPageJobsGetter'
    ])
  },
  async created () {
    await this.getJobsBy()
    await this.getCategories()
    await this.getIdentities()
    await this.getDepartments()
    await this.getRegions()
  },
  methods: {
    ...mapActions('pages/jobs', [
      'getCategories',
      'getIdentities',
      'getDepartments',
      'getJobsBy',
      'getJobDetailsById',
      'getRegions',
      'getSubregions'
    ]),
    async searchJobs () {
      await this.getJobsBy(this.query)
    },
    toggleAdvancedSearchField () {
      this.doesActiveAdvancedSearching = !this.doesActiveAdvancedSearching
    },
    selectCategory (category) {
      this.query = Object.assign({}, this.query, {
        category: Number(category.category_value)
      })
    },
    selectRegion (region) {
      this.query = Object.assign({}, this.query, {
        region: Number(region.id)
      })
    },
    selectIdentity (identity) {
      this.query = Object.assign({}, this.query, {
        identity: Number(identity.identity_value)
      })
    },
    selectDepartment (department) {
      this.query = Object.assign({}, this.query, {
        department: Number(department.department_value)
      })
    },
    selectedRow (e, id) {
      this.$router.push({ path: `/job-opening/zh/${id}` })
    },
    resetQueryString () {
      this.query = Object.assign({})
    },
    updateJobsPage (page) {
      this.getJobsBy({ page, ...this.query })
    }
  }
}
</script>

<style lang="scss" scoped>
    .table_scroll{
        overflow-x:scroll!important;
    }
    .table_width{
        width: 1000px;
    }
    @media screen and (max-width: 640px) {
        .advanced-button {
            border: none;
            background: transparent !important;
        }
        .search-icon {
            border-radius: 99rem !important;
            padding: 5px 7px;
            height: 26px;
            margin-top: 5px;
        }
    }
</style>
